module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['jumbotron', _vm.fluid ? 'jumbotron-fluid' : null]
  }, [_c('div', {
    class: _vm.containerFluid ? 'container-fluid' : 'container'
  }, [(_vm.header) ? _c('h1', {
    staticClass: "display-3",
    domProps: {
      "innerHTML": _vm._s(_vm.header)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lead) ? _c('p', {
    staticClass: "lead",
    domProps: {
      "innerHTML": _vm._s(_vm.lead)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf716546"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/jumbotron.vue
// module id = 261
// module chunks = 0